import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../main/components/Header';
import Simulator from './Simulator';

const SimulatorLayout: React.FC = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'service-inclusive', 'tyres'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t(`tyre:header`)} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <Simulator />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SimulatorLayout;
